import { endpoint } from "../../../views/pages/manage/common/constant";
import { dropdownMapping } from "../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import SelectStudentWrapper from "./selectStudent/SelectStudentWrapper";
import SearchStudent from "./searchStudent";
import React from 'react';
import WizardTopHeader from "./selectStudent/topHeader/WizardTopHeader";
import SelectRefundReasonAndReceipt from "./rectificationRefund/selectRefundReasonAndReceipt";
import SelectPaymentMode from "./rectificationRefund/selectPaymentMode";
import { initialForm } from "../../../views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/constant";
import VerifyDetails from "./rectificationRefund/verifyDetails";
import { failureToast } from "../../../views/pages/manage/common/utils/methods/toasterFunctions/function";
import SelectRefundItems from "./multiTypeRefund/selectRefundItems";
import SelectRefundAccounts from "./multiTypeRefund/selectRefundAccounts";
import VerifyMultiTypeRefundDetails from "./multiTypeRefund/verifyDetails";
import { multiTypeRefundDetailsEmptyForm } from "./multiTypeRefund/utils";

export const RECTIFICATION_REFUND = "RECTIFICATION_REFUND";
export const COMPLETION_REFUND = "COMPLETION_REFUND";
export const MULTI_TYPE_REFUND = "MULTI_TYPE_REFUND";

export const getDropdowns = async () => {
  const dropdown = await Promise.all([
    dropdownMapping(endpoint?.term?.getAllActive, "termDispValue", "id"),

    // dropdownMapping(
    //   endpoint.academic_career.getAllActive,
    //   "academicCareerDispValue",
    //   "id"
    // ),
    // dropdownMapping(
    //   endpoint.academic_group.getAllActive,
    //   "academicGroupDispValue",
    //   "id"
    // ),
    dropdownMapping(
      endpoint.courseCatelogMapping.getAllActiveCourseIds,
      "courseIds"
    ),
    dropdownMapping(
      endpoint.businessArea.getAllActiveV2,
      "businessAreaDispValue",
      "id",
      "businessAreaDesc"
    ),
    dropdownMapping(
      endpoint.programAction.getAllActive,
      "programActionKey",
      "programActionKey",
    ),
    dropdownMapping(
      endpoint.businessUnitType.getAllBusinessUnitType,
      "businessUnitTypeDispValue",
      "id",
    ),
  ]);

  return {
    term: dropdown[0],
    // academicCareer: dropdown[1],
    // stream: dropdown[2],
    courseIds: dropdown[1],
    businessAres: dropdown[2],
    programActions: dropdown[3],
    branchTypes: dropdown[4],
  };
};

const validateStudentForRectRefund = (studentDetails) => {
  const restrictedProgramActions = ["DISC", "IBTR", "CRCG", "STCG", "MLBA"];
  const {programAction} = studentDetails;
  if (restrictedProgramActions?.includes(programAction)) {
    failureToast(`Cannot raise Rectificaton Refund request for ${programAction} program action!`);
    return false;
  }

  return true;
}

export const refundTypes = [
  {
    label: 'Rectification Refund',
    description: '',
    value: RECTIFICATION_REFUND,
    tips: [
      "Students with the following statuses are not eligible for rectification refund: DISC (Discontinued), IBTR (Branch Transfer), CRCG (Course/Career Change), or STCG (Stream/Term Change)",
      "Rectification Refund can be initiated for any fee component that is partially paid, i.e., if the item type is partially paid"
    ],
    validateStudent: validateStudentForRectRefund
  },
  {
    label: 'Multi-type Refund',
    description: 'Includes Discretionary, Withdrawal, Security and Full Refund',
    value: MULTI_TYPE_REFUND,
    tips: {
      "Security Refund": [
        "Balance should be positive",
        "No refund is raised for the same student/term",
        "Course should be completed",
        "Student should be DISC",
        "To prevent SAP or payment issues, don’t use or remove special characters in bank details"
      ],
      "Withdrawal Refund": [
        "Student should be DISC",
        "For loan cases, first refund the security amount if any",
        "For loan cases, parent and third party account details must be processed with SAP"
      ],
      "Full Refund": [
        "Student should be DISC",
        "All realised payments will be refunded"
      ],
      "Concession Refund": [
        "Student must be ACTIVE"
      ],
      "Discretionary Refund": [
        "Used for exceptions or emergencies",
        "Always provide remarks justifying discretionary payout"
      ]
    },
    validateStudent: () => true,
  },
]

const selectStudentStep = {
  id: "selectStudent",
  label: "Select Student",
  component: SelectStudentWrapper,
}

const rectificationRefundSteps = [
  {
    id: "selectReceipt",
    label: "Select A Receipt",
    component: SelectRefundReasonAndReceipt,
  },
  {
    id: "addRefundAccounts",
    label: "Choose Payment Mode",
    component: SelectPaymentMode,
  },
  {
    id: "verifyDetails",
    label: "Verify Details",
    component: VerifyDetails,
  },
]

const multiTypeRefundSteps = [
  {
    id: "chooseRefundItems",
    label: "Choose Refund Items",
    component: SelectRefundItems,
  },
  {
    id: "addRefundAccounts",
    label: "Add Refund Accounts",
    component: SelectRefundAccounts,
  },
  {
    id: "verifyDetails",
    label: "Verify Details",
    component: VerifyMultiTypeRefundDetails,
  },

]

export const rectRefundStep2InitValues = {
  refundDetailsForm: {},
  studentDetailsCorrectionForm: {},
  receiptsData: [],
  receiptsSelectionModel: [],
  receiptsFilterForm : {},
}

export const rectRefundStep3InitValues = {
  currentPaymentMode: "default",
  paymentModeForm: initialForm,
  // balanceAmount : 0,
  balanceMode: false,
  collectPayment: [],
  collectVoucherList: [],
  paymentModeIdLimitList: { paymentModeIdList: [], maxLimit: "" },
  modifyPaymentModeData: {},
  totalUnpaidAmount: 0
}

export const multiTypeRefundStep2InitValues = {
  // studentLoanDetails : null,
    refundDetailsForm : multiTypeRefundDetailsEmptyForm(),
    payableRefundInfo : null,
    selectedRefundItems : [],
    showFullRefundItem : false,
}

export const multiTypeRefundStep3InitValues = {
  // studentAccountDetails : [],
  // loanVendorAccountDetails : {}
}

export const refundStepsEmptyForms = {
  rectRefundStep2Data: rectRefundStep2InitValues,
  rectRefundStep3Data: rectRefundStep3InitValues,
  multiTypeRefundStep2Data : multiTypeRefundStep2InitValues,
  multiTypeRefundStep3Data : multiTypeRefundStep3InitValues
}


export const studentRefundWizardConfig = {
  resource: "users",
  api: {
    fetch: (id) => `/api/users/${id}`,
    create: () => `/api/users`,
    update: (id) => `/api/users/${id}`,
  },
  searchWizard: {
    isShow: true,
    component: SearchStudent,
  },
  fetchDropdown: getDropdowns,
  initialValues: {
    refundType: refundTypes[0],
    selectedStudent: "",
    searchStudentsListing: {
      list: [],
    },
    searchStudentsFilters: {},
    multiTypeRefundUtils : {},
    ...refundStepsEmptyForms
  },
  steps: [
    selectStudentStep,
    ...rectificationRefundSteps
  ],
  topHeader: WizardTopHeader
};


export const getStepsByRefundType = refundType => {
  switch (refundType) {
    case RECTIFICATION_REFUND: {
      return [selectStudentStep, ...rectificationRefundSteps]
    }
    case MULTI_TYPE_REFUND: {
      return [selectStudentStep, ...multiTypeRefundSteps]
    }
  }
}